<template>
    <span>
        <span v-if="!loading">

            <span v-if="playerOnline">
                <i class="fas fa-wifi text-success mr-1"></i> Online
            </span>

            <span v-else>

                <span v-if="playerLastOnline">
                    <i class="fas fa-wifi text-danger mr-1"></i> Offline {{ playerLastOnline }}
                </span>

                <span v-else>
                    <i class="fas fa-wifi text-muted mr-1"></i> Nunca foi Conectado
                </span>

            </span>

        </span>

        <span v-else>
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Carregando ...
        </span>

    </span>
</template>

<script>
export default {
    props: ['player'],
    data() {
        return {
            loading: false,
            playerData: this.player,
            playerOnline: null,
            playerLastOnline: null,
            timerSyncedData: null,
            channel: Echo.channel('App.Player.' + this.player.id),
        }
    },
    watch: {
        async player(playerNew, playerOld) {
            // Update Player
            this.playerData = playerNew;

            // Update Date
            this.playerOnline = await this.calcPlayerOnline(playerNew.last_activity);

            // Update Last Update
            this.playerLastOnline = await this.calcPlayerLastOnline(playerNew.last_activity);

            // Unsubscribe
            await this.channel.unsubscribe();

            // Start Channel Listener
            this.channel = await Echo.channel('App.Player.' + playerNew.id);

            // Subscribe
            this.channel.subscribe();

            // Event
            await this.channel
                .listen('.ping-from-player', (e) => {
                    // Update Player Data
                    this.playerData = e.player;
                })

        }
    },
    async mounted() {
        // Loading
        this.loading = true;

        // Search Last Activity in Api
        await this.loadLastActivity();

        // Update Date
        this.playerOnline = await this.calcPlayerOnline(this.playerData.last_activity);

        // Update Last Update
        this.playerLastOnline = await this.calcPlayerLastOnline(this.playerData.last_activity);

        // Disable Loading
        this.loading = false

        // Unsubscribe
        await this.channel.unsubscribe();

        // Start Channel Listener
        this.channel = await Echo.channel('App.Player.' + this.playerData.id);

        // Subscribe
        await this.channel.subscribe();

        // Event
        this.channel
            .listen('.ping-from-player', (e) => {
                // Update Player Data
                this.playerData = e.player;
            })

        // Timer Synced
        this.timerSyncedData = setInterval(() => {

            // Update Date
            this.playerOnline = this.calcPlayerOnline(this.playerData.last_activity);

            // Update Last Update
            this.playerLastOnline = this.calcPlayerLastOnline(this.playerData.last_activity);

        }, 1000)

    },
    beforeDestroy() {
        // Unsubscribe
        Echo.channel('App.Player.' + this.playerData.id).unsubscribe();

        // Cancel Interval
        clearInterval(this.timerSyncedData);
    },
    methods: {

        loadLastActivity() {
            return axios
                .get('/players/' + this.playerData.id + '/last-activity')
                .then(result => {
                    this.playerData.last_activity = result.data.last_activity;
                })
        },

        calcPlayerOnline(last_activity) {
            if (last_activity) {
                if (this.diffInSecondsDate(last_activity) <= 55) {
                    return true;
                }
            }

            return false;
        },

        calcPlayerLastOnline(last_activity) {
            if (last_activity) {
                return this.$moment(last_activity).fromNow()
            }

            return null
        },

        diffInSecondsDate(date) {
            const start = new Date(date).getTime();
            const end = new Date().getTime();
            const diff = end - start;
            return Math.floor(diff / 1000)
        }
    }
}
</script>

<style>

</style>
